module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAATxJREFUOE+FkrtKRDEQhr8suC9gZ6ONKIK4hWBvua8glmeC2KhgYyFuYyHipRDJpBT7rXwHZUGxEBYbbexsBRXOuJFz5ODe0iR/Jl8m808cxRCRG2Cq1EPmN1VtppirgC/AB3A3BFoFclWd6QOdc+0QwtYgMMuydi/e+ANF5BxYAlaACeB7SMY68AXcAh0nIgZ8Al2gNqbGHJgH6iXYUtWDEvLeL4QQnpKurgvdMrP9EtxW1bOKUSl7cjmNpqrOVWLJg9M+0Ht/aGYCTBaH351zGkLYS1pEBoM99xrOuWUzW/u13blrM+vEGB9GgiJyki4uHE5nk8uqqjsjQe/9bJ7nqaaN4qmXtVqtG0J47gPNbDfGeFxtRZZl60nHGK+q+yKyCxyV5rwCFyOaX7Lpg2wC0wl8BBbHNP5/+P4HHnaVhtoaIKEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/menus_icon/jsgl.png
// module id = Yvyg
// module chunks = 3